module.exports = __webpack_public_path__ + "static/media/badge-android.f5e134e8.png";